import RightTableList from '@/components/Shared/RightTableList';
import React from 'react';
import {
  Image_Subtypes_Enum,
  Order_By,
  useGetBannerQuery,
  useGetPostsQuery,
} from '@/generated/graphql';
import format from '@/utils/format';
import { useRouter } from 'next/router';
import { BannerCustomizeHeight } from '../Shared';

const RightSideBar = () => {
  const router = useRouter();
  const { data: DataLatest } = useGetPostsQuery({
    variables: {
      limit: 4,
      orderBy: {
        published_at: Order_By.DescNullsLast,
      },
      where: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
      },
    },
  });
  const { data: DataHostest } = useGetPostsQuery({
    variables: {
      limit: 4,
      orderBy: [
        {
          is_hot: Order_By.DescNullsLast,
        },
        { pin_at: Order_By.DescNullsLast },
        { published_at: Order_By.DescNullsLast },
      ],
      where: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
      },
    },
  });

  const { data: dataBanner } = useGetBannerQuery({
    variables: {
      where: {
        _or: [
          {
            _and: [
              {
                position: {
                  _in: [
                    Image_Subtypes_Enum.PostDetailRight_1,
                    Image_Subtypes_Enum.PostDetailRight_2,
                    Image_Subtypes_Enum.PostDetailBottom,
                    Image_Subtypes_Enum.SearchBottom_1,
                    Image_Subtypes_Enum.SearchBottom_2,
                    Image_Subtypes_Enum.SearchBottom_3,
                  ],
                },
                banners_categories: {
                  category: {
                    slug: {
                      _eq: router.query.slug?.[0],
                    },
                  },
                },
              },
            ],
          },
          {
            _and: [
              {
                position: {
                  _in: [
                    Image_Subtypes_Enum.PostDetailRight_1,
                    Image_Subtypes_Enum.PostDetailRight_2,
                    Image_Subtypes_Enum.PostDetailBottom,
                    Image_Subtypes_Enum.SearchBottom_1,
                    Image_Subtypes_Enum.SearchBottom_2,
                    Image_Subtypes_Enum.SearchBottom_3,
                  ],
                },
                banners_categories_aggregate: {
                  count: {
                    predicate: {
                      _eq: 0,
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      orderBy: [
        {
          banners_categories_aggregate: {
            count: Order_By.DescNullsLast,
          },
        },
      ],
    },
  });
  return (
    <div className="h-full">
      <div
        className="flex flex-col gap-6 py-5 sticky top-0"
        style={{
          animation: 'animate-moveinright 0.5s ease-in-out',
        }}
      >
        <div className="w-full">
          <BannerCustomizeHeight
            data={dataBanner?.banners.filter(
              item => item.position === Image_Subtypes_Enum.PostDetailRight_1,
            )}
          />
        </div>

        <RightTableList
          key={1}
          title="Tin nóng"
          data={format.formatDataPost(DataHostest?.posts)}
        />

        <div className="w-full">
          <BannerCustomizeHeight
            data={dataBanner?.banners.filter(
              item => item.position === Image_Subtypes_Enum.PostDetailRight_2,
            )}
          />
        </div>

        <RightTableList
          key={0}
          title="Tin mới"
          data={format.formatDataPost(DataLatest?.posts)}
        />
      </div>
    </div>
  );
};

export default RightSideBar;
